import {NgModule} from '@angular/core';
import {ManageStayComponent} from './manage-stay/manage-stay.component';
import {ComponentsModule} from '../../components/components.module';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';

const routes: Routes = [
  { path: '', component: ManageStayComponent }
];
@NgModule({
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    ComponentsModule
  ],
  declarations: [
    ManageStayComponent
  ],
  exports: [
    ManageStayComponent
  ]
})
export class ManageStayModule {
  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/routes/manage-stay/manage-stay.module.ts